import { createApp } from 'vue'

import App from '@/App.vue'
import messages from '@/lang/index.json'
import router from '@/router/index'
import '@/style.css'
import { createI18n } from 'vue-i18n'

const BRAND = import.meta.env.PUBLIC_APP_BRAND.toLowerCase()

const i18n = createI18n({
  locale: 'de',
  fallbackLocale: 'en',
  messages,
})

const app = createApp(App)

app.provide('BRAND', BRAND)

app.use(router)
app.use(i18n)
app.mount('#app')
